import React from 'react';
import "../CSS/Testimonials.scss"

const Testimonials = () => {
    return ( 
        <section className="testDiv" id="testimonials">
            <div>
                <h1 className="title">WHAT OUR CUSTOMERS ARE SAYING...</h1>
            </div>
        </section>
     );
}
 
export default Testimonials
